export enum OrderStatus {
  PENDING = 'Pending',
  APPROVED = 'Approved',
  ACCEPTED = 'Accepted',
  ACQUIRED = 'Acquired',
  DRIVER_REACHED_BRANCH = 'DriverReachedBranch',
  PICKED_UP = 'PickedUp',
  DELIVERING = 'Delivering',
  AT_DESTINATION = 'AtDestination',
  COMPLETED = 'Completed',
  NOT_DELIVERED = 'NotDelivered',
  CANCELED = 'Canceled'
}
